import React from 'react';
import { string, func, bool } from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';

import css from './AuthTabSwitcher.module.css';

/**
 * AuthTabSwitcher component for authentication pages
 * Shows only the opposite tab (signup when on login, login when on signup)
 */
const AuthTabSwitcher = props => {
  const { rootClassName, className, isLogin, onTabClick } = props;

  // Define button color based on current page
  const getButtonColor = () => {
    return isLogin ? 'var(--colorRepozeLightBlue)' : 'var(--colorRepozeDarkBrown)';
  };

  const classes = classNames(rootClassName || css.root, className, {
    [css.rootLogin]: isLogin,
  });
  const rootStyle = {
    '--tab-button-color': getButtonColor(),
  };

  // Determine which tab to show based on current form
  const tabToShow = isLogin ? 'signup' : 'login';
  const tabText = isLogin ? (
    <FormattedMessage id="AuthenticationPage.signupLinkText" />
  ) : (
    <FormattedMessage id="AuthenticationPage.loginLinkText" />
  );

  const handleTabClick = (e) => {
    e.preventDefault();
    onTabClick(tabToShow);
  };

  return (
    <div className={classes} style={rootStyle}>
      <button
        type="button"
        className={isLogin ? css.tabButtonLogin : css.tabButton}
        onClick={handleTabClick}
      >
        {tabText}
      </button>
    </div>
  );
};

AuthTabSwitcher.propTypes = {
  rootClassName: string,
  className: string,
  isLogin: bool.isRequired,
  onTabClick: func.isRequired,
};

export default AuthTabSwitcher;
